export enum ContainerStatusEnum {
    NOT_READY = 'NOT READY',
    READY_TO_BOOK = 'READY TO BOOK',
    BOOKED = 'BOOKED',
    DISPATCHED_TO_PLANT = 'DISPATCHED TO PLANT',
    LOADING = 'LOADING',
    LOADED_AND_SEALED = 'LOADED AND SEALED',
    SHIPPED = 'SHIPPED',
    OPEN = "OPEN"
}